import { Dispatch, FC, SetStateAction } from 'react';
import { HStack } from '@chakra-ui/react';

import Chip from 'components/_core/Chip';

import { type Tab } from '../../../../filters';
import locales from './locales';

interface StatusBarProps {
  selected: Tab;
  onTabChange: Dispatch<SetStateAction<Tab>>;
}

type TabDescription<T extends Tab> = {
  id: T;
  titleKey: keyof typeof locales.filters;
};

const TABS: TabDescription<Tab>[] = [
  {
    id: 'pending',
    titleKey: 'pending',
  },
  {
    id: 'closed',
    titleKey: 'done',
  },
];

const StatusBar: FC<StatusBarProps> = ({ onTabChange, selected }) => (
  <HStack spacing="space-16">
    {TABS.map((tab) => (
      <Chip
        isActive={selected === tab.id}
        key={tab.id}
        onClick={() => onTabChange(tab.id)}
      >
        {locales.filters[tab.titleKey]}
      </Chip>
    ))}
  </HStack>
);

export default StatusBar;
